---
title: Workspace memory
lede: What every agent of a workspace is told to keep in mind — your terms, your way of working.
order: 47
part: Teams and settings
---

A workspace's memory is a short text every agent of that workspace starts with: the words you want kept (`Invoice`, never a translation), how you like things done, what to avoid. A preference an agent only keeps in its session is gone with it; the memory carries it to every new session of the workspace.

It is yours. It stays on this computer and is never shared with an [organization](/organization), and the team's [Rules](/rules) win wherever the two disagree.

### When an agent is asked to remember

Tell an agent "remember that…" and it does not write the memory itself: it suggests one line, and a card asks **Remember for** *your workspace's name*?

- **Remember** adds the line. The card answers *Remembered · new sessions start with it*.
- **Discard** drops it. The card answers *Discarded · nothing kept*.

An unanswered suggestion goes away with the session that made it. A line that looks like a password or a key is never suggested.

### Editing it

Open [Workspace settings](/workspace-settings) → **Memory**. The field holds the whole text, one preference per line, up to 4,000 characters; write each line as an instruction to an agent, for example « Keep the code's own names in your explanations. » **Save memory** saves it, and the workspace form's own **Save** does too. To clear it, empty the field and save.

What you save reaches every agent set up after it — a new session, or a side agent started in a running one. An agent already running keeps the memory it started with.
